var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('span',{staticClass:"text-h5",attrs:{"id":"title_first"}},[_vm._v("Food")]),_c('span',{staticClass:"text-h5",attrs:{"id":"title_second"}},[_vm._v("Office")])])}
var staticRenderFns = []

export { render, staticRenderFns }